import { toast } from 'react-toastify';

import { useApiLazyQuery } from '@common/hooks';
import DataService from '@core/services/DataService';

import { printPaymentTermsQuery } from '../services';
import { FileDownloadResult } from '../types/regeneratePolicyDocuments.types';

interface PrintPaymentTermsVariables {
  policyPaymentId: string;
}

interface PrintPaymentTermsResponse {
  production: {
    printPaymentTerms: FileDownloadResult;
  };
}

export function usePrintPaymentTerms() {
  const [fetchPrintPaymentTerms, { loading }] = useApiLazyQuery<
    PrintPaymentTermsResponse,
    PrintPaymentTermsVariables
  >(printPaymentTermsQuery, 'printPaymentTerms', undefined, {
    withLoader: true
  });

  const printPaymentTerms = async (
    policyPaymentId: string
  ): Promise<void | null> => {
    if (!policyPaymentId) return null;

    try {
      const response = await fetchPrintPaymentTerms({
        variables: { policyPaymentId }
      });

      const file = response?.data?.production?.printPaymentTerms;

      if (!file?.content) return null;

      DataService.downloadBase64File(
        file.content,
        file.contentType,
        file.fileName
      );

      toast.success('Payment Terms downloaded successfully!');
    } catch (err) {
      console.error('Error printing payment terms:', err);

      return null;
    }
  };

  return { printPaymentTerms, loading };
}
